<template>
  <div>
    <div v-if="loading" class="text-center bg-gray-200 p-4 rounded">
      <Loader />
    </div>

    <div v-else-if="pages.length" class="list list-spaced rounded">
      <div class="px-4 py-2 font-medium text-sm bg-gray-200 uppercase text-gray-600">Name</div>

      <PageLine
        v-for="line in pages"
        :key="line.uuid"
        :page="line"
        @page-preview="previewPage"
        @page-stats="viewPageStats"
        @page-edit="editPage"
        @page-delete="confirmDeletePage"
      />
    </div>

    <div v-else class="bg-gray-200 p-6 text-center rounded">No pages found.</div>

    <portal v-if="page && isActionPreview" to="app-dialog">
      <ModalMobilePreview :page="page" @closed="resetAction" />
    </portal>

    <portal v-if="page && isActionStats" to="app-dialog">
      <ModalStats :page="page" @closed="resetAction" />
    </portal>

    <portal v-if="page && isActionEdit" to="app-dialog">
      <ModalEdit
        :account-id="page.accountId"
        :page="page"
        :action="doUpdate"
        @closed="resetAction"
      />
    </portal>

    <portal v-if="page && isActionDelete" to="app-dialog">
      <BaseDialogDelete
        danger
        :custom-classes="'max-w-md'"
        @closed="resetAction"
        @confirmed="doDeletePage"
      />
    </portal>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import ModalEdit from '@/components/ProjectPage/ModalCreateOrEdit.vue';
import ModalStats from './ModalStats.vue';
import ModalMobilePreview from './ModalMobilePreview.vue';
import PageLine from './PageLine.vue';

const ACTION_PREVIEW = 'preview';
const ACTION_STATS = 'stats';
const ACTION_EDIT = 'edit';
const ACTION_DELETE = 'delete';

export default {
  components: {
    PageLine,
    ModalStats,
    ModalMobilePreview,
    ModalEdit,
  },

  props: {
    loading: Boolean,
    pages: { type: Array, default: () => [] },
  },

  data: () => ({
    pending: false,
    action: null,
  }),

  computed: {
    ...mapGetters('ui/pages', ['page']),

    isActionPreview() {
      return this.action === ACTION_PREVIEW;
    },

    isActionStats() {
      return this.action === ACTION_STATS;
    },

    isActionEdit() {
      return this.action === ACTION_EDIT;
    },

    isActionDelete() {
      return this.action === ACTION_DELETE;
    },
  },

  methods: {
    ...mapActions('ui/pages', ['updatePage', 'deletePage']),

    ...mapMutations('ui/pages', ['setCurrent']),

    viewPageStats(page) {
      this.setCurrent(page.id);
      this.action = ACTION_STATS;
    },

    previewPage(page) {
      this.setCurrent(page.id);
      this.action = ACTION_PREVIEW;
    },

    editPage(page) {
      this.setCurrent(page.id);
      this.action = ACTION_EDIT;
    },

    confirmDeletePage(page) {
      this.setCurrent(page.id);
      this.action = ACTION_DELETE;
    },

    resetAction() {
      this.setCurrent(null);
      this.action = null;
    },

    doUpdate(pageData) {
      return this.updatePage({ pageId: this.page.id, pageData });
    },

    async doDeletePage() {
      this.pending = true;

      try {
        const { pageId } = await this.deletePage({ pageId: this.page.id });
        this.$emit('page-deleted', pageId);
        this.resetAction();
      } catch (error) {
        //
      }

      this.pending = false;
    },
  },
};
</script>
